export const NotFounView = () => {
  return <div>404 page not found!</div>;
};

export default NotFounView;
